import { render, staticRenderFns } from "./SingleLineText.vue?vue&type=template&id=cc08f870"
import script from "./SingleLineText.vue?vue&type=script&lang=ts"
export * from "./SingleLineText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports